import React from "react"
import { StaticImage } from "gatsby-plugin-image"

export const Footer = () => {
  return (
    <footer>
      <div className="footer-inner-wrapper">
        <div className="footer--actions">
          <div>
            <p className="footer-list-heading">Category</p>
            <ul className="footer-list">
              <li className="footer-list--item">
                <a href="/">Home</a>
              </li>
              <li className="footer-list--item">
                <a href="/tools/">Tools</a>
              </li>
              <li className="footer-list--item">
                <a href="/shorts/">Shorts</a>
              </li>
            </ul>
          </div>
          <div>
            <p className="footer-list-heading">Website</p>
            <ul className="footer-list">
              <li className="footer-list--item">
                <a href="/about-us/">About</a>
              </li>
              <li className="footer-list--item">
                <a href="/privacy-policy/">Privacy policy</a>
              </li>
            </ul>
          </div>
          <div>
            <p className="footer-list-heading">Social</p>
            <ul className="footer-list">
              <li className="footer-list--item">
                <a
                  href="https://github.com/isamrish"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Github
                </a>
              </li>
              <li className="footer-list--item">
                <a
                  href="https://twitter.com/isamrishk"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </li>
            </ul>
          </div>
          <div>
            <StaticImage
              alt={"Frontendroom"}
              src="../../images/frontendroom.png"
              height={60}
              style={{ marginTop: "16px" }}
            />
          </div>
        </div>
        <div className="footer--copyright">
          <span>
            © {new Date().getFullYear()} &middot; Copyright Frontendroom
          </span>
        </div>
      </div>
    </footer>
  )
}
